export enum BillType {
  INVOICE = 'invoice',
  RECEIPT = 'receipt',
  CASH_ADVANCE = 'cash_advance',
}

export const billTypeLabel = {
  [BillType.INVOICE]: 'Invoice',
  [BillType.RECEIPT]: 'Receipt',
  [BillType.CASH_ADVANCE]: 'Cash Advance',
};

export const billTypePaymentVendors = {
  [BillType.INVOICE]: 'Invoice Funding',
  [BillType.RECEIPT]: 'Receipt',
  [BillType.CASH_ADVANCE]: 'Cash Advance',
};
